import { render, staticRenderFns } from "./cardChartInfo.vue?vue&type=template&id=6b97e8a2&scoped=true"
import script from "./cardChartInfo.vue?vue&type=script&lang=js"
export * from "./cardChartInfo.vue?vue&type=script&lang=js"
import style0 from "./cardChartInfo.vue?vue&type=style&index=0&id=6b97e8a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b97e8a2",
  null
  
)

export default component.exports